module.exports = __webpack_public_path__ + "fonts/iconfont.d60d1e8c.woff2";